type PlaceStampImageProps = {
  src: string
  alt: string
  className?: string
  imageClassName?: string
  padClassName?: string
  rotation?: number
  loading?: 'lazy' | 'eager'
  width?: number
  height?: number
}

/**
 * Pieczątki mają czarne tło w pliku PNG — na ciemnym motywie lub hero
 * potrzebują stałego jasnego podłoża, żeby były czytelne.
 */
export function PlaceStampImage({
  src,
  alt,
  className = '',
  imageClassName = 'h-full w-full object-contain',
  padClassName = '',
  rotation = 0,
  loading = 'lazy',
  width,
  height,
}: PlaceStampImageProps) {
  return (
    <div
      className={[
        'grid place-items-center rounded-lg bg-[#f5f0e8] p-2 ring-1 ring-black/10 shadow-[0_10px_24px_rgba(0,0,0,0.14)]',
        'transition-transform duration-300 ease-out hover:rotate-0 hover:scale-[1.04]',
        'dark:bg-[#f5f0e8] dark:ring-white/15',
        padClassName,
        className,
      ].join(' ')}
      style={rotation ? { transform: `rotate(${rotation}deg)` } : undefined}
    >
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        loading={loading}
        decoding="async"
        draggable={false}
        className={imageClassName}
      />
    </div>
  )
}
